module.exports = __webpack_public_path__ + "static/media/Genevan-Psalms-in-Harmony-4.64ac8727.jpg";